import { DesktopShell } from "@circleco/compass/components/DesktopShell";

import { DOM_IDS } from "./defaults";
import { withFixedProps } from "./withFixedProps";

const DockRoot = withFixedProps(DesktopShell.Dock.Root, {
  "data-testid": "circle-ai-shell-dock",
});
const DockHeader = withFixedProps(DesktopShell.Dock.Header, {
  "data-testid": "circle-ai-shell-dock-header",
});
const DockBody = withFixedProps(DesktopShell.Dock.Body, {
  id: DOM_IDS.dockBody,
  "data-testid": "circle-ai-shell-dock-body",
});
const DockFooter = withFixedProps(DesktopShell.Dock.Footer, {
  "data-testid": "circle-ai-shell-dock-footer",
});

export const CompassDock = Object.assign(DockRoot, {
  Header: DockHeader,
  Body: DockBody,
  Footer: DockFooter,
});

const SidebarRoot = withFixedProps(DesktopShell.Sidebar.Root, {
  "data-testid": "circle-ai-shell-sidebar-root",
});
const SidebarHeader = withFixedProps(DesktopShell.Sidebar.Header, {
  "data-testid": "circle-ai-shell-sidebar-header",
});
const SidebarBody = withFixedProps(DesktopShell.Sidebar.Body, {
  id: DOM_IDS.communityLeftSidebarBody,
  "data-testid": "circle-ai-shell-left-sidebar-body",
});
const SidebarFooter = withFixedProps(DesktopShell.Sidebar.Footer, {
  "data-testid": "circle-ai-shell-sidebar-footer",
});

export const CompassSidebar = Object.assign(SidebarRoot, {
  Header: SidebarHeader,
  Body: SidebarBody,
  Footer: SidebarFooter,
});

const PanelRoot = withFixedProps(DesktopShell.Panel.Root, {
  "data-testid": "circle-ai-shell-panel-root",
});
const PanelHeader = withFixedProps(DesktopShell.Panel.Header, {
  "data-testid": "circle-ai-shell-panel-header",
});
const PanelBody = withFixedProps(DesktopShell.Panel.Body, {
  id: DOM_IDS.communityRightSidebarBody,
  "data-testid": "circle-ai-shell-panel-body",
});
const PanelFooter = withFixedProps(DesktopShell.Panel.Footer, {
  "data-testid": "circle-ai-shell-panel-footer",
});

export const CompassPanel = Object.assign(PanelRoot, {
  Header: PanelHeader,
  Body: PanelBody,
  Footer: PanelFooter,
});

const ConversationPanelRoot = withFixedProps(
  DesktopShell.ConversationPanel.Root,
  {
    "data-testid": "circle-ai-shell-conversation-panel",
  },
);
const ConversationPanelHeader = withFixedProps(
  DesktopShell.ConversationPanel.Header,
  {
    "data-testid": "circle-ai-shell-conversation-panel-header",
  },
);
const ConversationPanelBody = withFixedProps(
  DesktopShell.ConversationPanel.Body,
  {
    id: DOM_IDS.conversationPanelBody,
    "data-testid": "circle-ai-shell-conversation-panel-body",
  },
);
const ConversationPanelFooter = withFixedProps(
  DesktopShell.ConversationPanel.Footer,
  {
    "data-testid": "circle-ai-shell-conversation-panel-footer",
  },
);

export const CompassConversationPanel = Object.assign(ConversationPanelRoot, {
  Header: ConversationPanelHeader,
  Body: ConversationPanelBody,
  Footer: ConversationPanelFooter,
});

const CanvasRoot = withFixedProps(DesktopShell.Canvas.Root, {
  "data-testid": "circle-ai-shell-canvas",
});
const CanvasHeader = withFixedProps(DesktopShell.Canvas.Header, {
  "data-testid": "circle-ai-shell-canvas-header",
});
const CanvasBody = withFixedProps(DesktopShell.Canvas.Body, {
  "data-testid": "circle-ai-shell-canvas-body",
});
const CanvasFooter = withFixedProps(DesktopShell.Canvas.Footer, {
  "data-testid": "circle-ai-shell-canvas-footer",
});

export const CompassCanvas = Object.assign(CanvasRoot, {
  Header: CanvasHeader,
  Body: CanvasBody,
  Footer: CanvasFooter,
});

const WorkspaceRoot = withFixedProps(DesktopShell.Workspace.Root, {
  "data-testid": "circle-ai-shell-workspace-root",
});
const WorkspaceHeader = withFixedProps(DesktopShell.Workspace.Header, {
  "data-testid": "circle-ai-shell-workspace-header",
});
const WorkspaceBody = withFixedProps(DesktopShell.Workspace.Body, {
  id: DOM_IDS.workspaceBody,
  "data-testid": "circle-ai-shell-workspace-body",
});
const WorkspaceFooter = withFixedProps(DesktopShell.Workspace.Footer, {
  "data-testid": "circle-ai-shell-workspace-footer",
});

export const CompassWorkspace = Object.assign(WorkspaceRoot, {
  Header: WorkspaceHeader,
  Body: WorkspaceBody,
  Footer: WorkspaceFooter,
});

const InsetRoot = withFixedProps(DesktopShell.Inset.Root, {
  "data-testid": "circle-ai-shell-inset-root",
});
const InsetHeader = withFixedProps(DesktopShell.Inset.Header, {
  "data-testid": "circle-ai-shell-inset-header",
});
const InsetBody = withFixedProps(DesktopShell.Inset.Body, {
  "data-testid": "circle-ai-shell-inset-body",
});

export const CompassInset = Object.assign(InsetRoot, {
  Header: InsetHeader,
  Body: InsetBody,
});
